import * as client_hooks from '../../../../src/hooks.client.ts';


export const matchers = {};

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1')
];

export const server_loads = [0];

export const dictionary = {};

export const hooks = {
	handleError: client_hooks.handleError || (({ kind, error }) => { if (kind === 'unknown') { console.error(error); } }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);